import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import StarIcon from '@mui/icons-material/Star';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
const reviews = [{
  name: 'Mariana G.',
  location: 'Buenos Aires',
  text: 'Llené mi freezer un domingo y no volví a cocinar en 3 semanas. Mi familia no puede creer que todo es casero. ¡Cambió mi vida!',
  rating: 5
}, {
  name: 'Lucas P.',
  location: 'Córdoba',
  text: 'Vivo solo y antes pedía delivery todos los días. Ahora gasto menos de la mitad y como mucho mejor. El método es genial.',
  rating: 5
}, {
  name: 'Sofía R.',
  location: 'Rosario',
  text: 'Soy mamá de 3 y trabajar todo el día me dejaba sin energía para cocinar. Con el Método 6:30 mis hijos comen sano sin que yo sufra.',
  rating: 5
}, {
  name: 'Diego M.',
  location: 'Mendoza',
  text: 'Pensé que la comida congelada iba a ser fea. Me equivoqué totalmente. Las recetas del Tomo II son increíbles, parecen recién hechas.',
  rating: 5
}];
export function GuaranteeSection() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % reviews.length);
    }, 4500);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-10 md:py-14 px-4 md:px-8 max-w-4xl mx-auto text-center" data-id="element-60">
      <FadeIn data-id="element-61">
        <VerifiedUserIcon sx={{
        fontSize: {
          xs: 40,
          md: 56
        }
      }} className="text-[#2D5A27] mb-4" data-id="element-62" />
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-63">
          Garantía de Satisfacción Total
        </h2>
        <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-64">
          "Probá el sistema por 7 días. Si no sentís que recuperaste el control
          de tu cocina y de tu dinero, te devolvemos el 100% de tu inversión.
          Sin preguntas. Queremos que estés 100% seguro."
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-65">
        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-5 md:mb-8" data-id="element-66">
          Lo que dicen nuestros alumnos
        </h3>

        <div className="relative bg-[#F5F5F5] rounded-2xl p-5 md:p-8 min-h-[180px] md:min-h-[220px] flex items-center justify-center overflow-hidden" data-id="element-67">
          <FormatQuoteIcon sx={{
          fontSize: 80
        }} className="absolute top-2 left-2 text-gray-200" data-id="element-68" />
          <AnimatePresence mode="wait" data-id="element-69">
            <motion.div key={current} initial={{
            opacity: 0,
            x: 40
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -40
          }} transition={{
            duration: 0.4,
            ease: 'easeInOut'
          }} className="relative z-10 flex flex-col items-center" data-id="element-70">
              <div className="flex gap-0.5 mb-3" data-id="element-71">
                {Array.from({
                length: reviews[current].rating
              }).map((_, i) => <StarIcon key={i} sx={{
                fontSize: 22
              }} className="text-[#FF9F43]" data-id="element-72" />)}
              </div>
              <p className="text-gray-700 text-lg md:text-xl leading-relaxed italic mb-4 max-w-2xl" data-id="element-73">
                "{reviews[current].text}"
              </p>
              <p className="font-bold text-gray-900" data-id="element-74">{reviews[current].name}</p>
              <p className="text-sm text-gray-500" data-id="element-75">
                {reviews[current].location}
              </p>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex justify-center gap-2 mt-5" data-id="element-76">
          {reviews.map((_, index) => <button key={index} onClick={() => setCurrent(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === current ? 'bg-[#2D5A27] w-6' : 'bg-gray-300'}`} aria-label={`Ver reseña ${index + 1}`} data-id="element-77" />)}
        </div>
      </FadeIn>
    </section>;
}